import qs from "qs";
import axios from "axios";
import Jsona from 'jsona';
import areIntervalsOverlappingWithOptions from "date-fns/fp/areIntervalsOverlappingWithOptions/index";


const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function getProfile(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/web/me`, options)
    .then(response => {
      return response.data;
    });
}

function update(profile) {
  const payload = jsona.serialize({
    stuff: profile,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/web/me`, payload, options)
    .then(response => {
      return response.data;
    });
}

function upload(member, image) {

  const bodyFormData = new FormData();
  bodyFormData.append('attachment', image);

  return axios.post(`${url}/web/me/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}

function changePassword(data) {

  const payload = jsona.serialize({
    stuff: data,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/web/me/password`, payload, options)
    .then(response => {
      return response.data;
    });
}

function checkAlias(input) {
  const payload = jsona.serialize({
    stuff: {
      type: 'profile',
      alias: input
    },
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/web/me/alias-check`, payload, options)
    .then(response => {
      return response.data;
    });
}


function addContact(input) {
  const payload = jsona.serialize({
    stuff: input,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/web/me/contact`, payload, options)
    .then(response => {
      return response.data;
    });
}

function updateContact(input) {
  const payload = jsona.serialize({
    stuff: input,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/web/me/contact/`+input.id, payload, options)
    .then(response => {
      return response.data;
    });
}

function deleteContact(id) {
  return axios.delete(`${url}/web/me/contact/`+id)
    .then(response => {
      return response.data;
    });
}

export default {
    getProfile,
    update,
    upload,
    checkAlias,
    changePassword,
    addContact,
    updateContact,
    deleteContact
};

